import { useState, useEffect } from "react";
import deleteIcon from "../../../../assets/delete-icon.svg";
import plusIcon from "../../../../assets/plus-button.svg";

export default function EditProfileExperience({
  details,
  handleCertificatesChange,
  handleDeleteCertificates,
  handleAddCertificates,
  handleExperienceChange,
  handleDeleteExperiences,
  handleAddExperience,
}) {
  const [certifications, setCertifications] = useState(
    details.certificates || []
  );
  const [experiences, setExperiences] = useState(details.experiences || []);

  // Sync local state when parent details update
  useEffect(() => {
    setCertifications(details.certificates || []);
  }, [details.certificates]);

  useEffect(() => {
    setExperiences(details.experiences || []);
  }, [details.experiences]);

  const updateCertification = (id, field, value) => {
    const updated = certifications.map((item) =>
      item.id === id ? { ...item, [field]: value } : item
    );
    setCertifications(updated);
    handleCertificatesChange(id, field, value);
  };

  const updateExperience = (id, field, value) => {
    const updated = experiences.map((item) =>
      item.id === id ? { ...item, [field]: value } : item
    );
    setExperiences(updated);
    handleExperienceChange(id, field, value);
  };

  const removeCertificate = (id) => {
    const filtered = certifications.filter((cert) => cert.id !== id);
    setCertifications(filtered);
    handleDeleteCertificates(id);
  };

  const removeExperience = (id) => {
    const filtered = experiences.filter((exp) => exp.id !== id);
    setExperiences(filtered);
    handleDeleteExperiences(id);
  };

  return (
    <div className="experience-edit-wrapper-parent">
      {/* Certifications Section */}
      <div className="certification-edit-wrapper">
        <div className="separator"></div>
        <span>Certifications</span>
        <div className="certifications-single-wrapper">
          <input
            type="hidden"
            name="certifications"
            value={JSON.stringify(certifications)}
          />
          {certifications.length === 0 ? (
            <p className="no-certificates">No certificates</p>
          ) : (
            certifications.map((curr) => (
              <div className="certifications-single-edit" key={curr.id}>
                <div className="certifications-single-edit__name">
                  <label>Name</label>
                  <input
                    type="text"
                    maxLength="40"
                    value={curr.name}
                    onChange={(e) =>
                      updateCertification(curr.id, "name", e.target.value)
                    }
                  />
                </div>
                <div className="certifications-single-edit__year">
                  <label>Finish Year</label>
                  <input
                    type="text"
                    maxLength="4"
                    value={curr.year_finished}
                    onChange={(e) =>
                      updateCertification(
                        curr.id,
                        "year_finished",
                        e.target.value
                      )
                    }
                  />
                </div>
                <div className="remove-wrapper">
                  <button
                    type="button"
                    onClick={() => removeCertificate(curr.id)}
                  >
                    <img src={deleteIcon} alt="delete icon" />
                    Remove
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
        <div className="add-button-all">
          <button type="button" onClick={handleAddCertificates}>
            <img src={plusIcon} alt="plus" />
            Add Certification
          </button>
        </div>
      </div>

      {/* Experience Section */}
      <div className="experience-edit-wrapper">
        <div className="separator"></div>
        <span>Experience</span>
        <input
          type="hidden"
          name="experiences"
          value={JSON.stringify(experiences)}
        />
        {experiences.length === 0 ? (
          <p>No experiences</p>
        ) : (
          experiences.map((curr) => (
            <div className="experience-single-wrapper" key={curr.id}>
              <div className="form-group">
                <label>Company</label>
                <input
                  type="text"
                  value={curr.company_name || ""}
                  onChange={(e) =>
                    updateExperience(curr.id, "company_name", e.target.value)
                  }
                />
              </div>
              <div className="form-group">
                <label>Role</label>
                <input
                  type="text"
                  value={curr.role || ""}
                  onChange={(e) =>
                    updateExperience(curr.id, "role", e.target.value)
                  }
                />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea
                  maxLength="500"
                  value={curr.description || ""}
                  onChange={(e) =>
                    updateExperience(curr.id, "description", e.target.value)
                  }
                ></textarea>
              </div>
              <div className="form-group">
                <label>Tenure</label>
                <div className="experience-duration-wrapper">
                  <div className="experience-duration-wrapper__from">
                    <input
                      type="date"
                      name="start_date"
                      value={curr.date_start || ""}
                      onChange={(e) =>
                        updateExperience(curr.id, "date_start", e.target.value)
                      }
                    />
                  </div>
                  <p>To</p>
                  <div className="experience-duration-wrapper__to">
                    <input
                      type="date"
                      name="end_date"
                      value={curr.date_end || ""}
                      onChange={(e) =>
                        updateExperience(curr.id, "date_end", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="remove-wrapper">
                <button type="button" onClick={() => removeExperience(curr.id)}>
                  <img src={deleteIcon} alt="delete icon" />
                  Remove
                </button>
              </div>
            </div>
          ))
        )}
        <div className="add-button-all">
          <button type="button" onClick={handleAddExperience}>
            <img src={plusIcon} alt="plus" />
            Add Experience
          </button>
        </div>
      </div>
    </div>
  );
}
